import { JSX } from 'react';

import { ComponentDynamicSvgArgs } from '../../components/types/component-dynamic-svg.type';

const SLAT_HEIGHT = 0.25;
const SLAT_RADIUS = 0.125;
const SLAT_Y = [1.125, 1.875, 2.625];
const GROUP_WIDTH = 8;
const GROUP_GAP = 3;
const DOUBLE_GROUP_WIDTH = (GROUP_WIDTH * 2) + GROUP_GAP;
const MIN_EDGE_MARGIN = 1.5;

// A bar-depth (or otherwise reduced-depth) MOK island's side panel is too narrow to carry both
// vent groups with a usable edge margin, so it gets a single centered group instead (GitHub #451).
const isSingleGroup = (panelWidth?: number): boolean => {
	return typeof panelWidth === 'number' && panelWidth < DOUBLE_GROUP_WIDTH + (2 * MIN_EDGE_MARGIN);
};

const ventSlats = (args: ComponentDynamicSvgArgs): JSX.Element => {
	const { x, y = -2, opacity = 1, panelWidth } = args;

	const single = isSingleGroup(panelWidth);
	const groupOffsets = single ? [0] : [0, GROUP_WIDTH + GROUP_GAP];
	const left = x ?? (single ? GROUP_WIDTH : DOUBLE_GROUP_WIDTH) / -2;

	return <g fill="white" stroke="none" transform={`translate(${left}, ${y})`} opacity={opacity}>
		{groupOffsets.flatMap((groupX) => SLAT_Y.map((slatY) => (
			<rect key={`${groupX}-${slatY}`} x={groupX} y={slatY} width={GROUP_WIDTH} height={SLAT_HEIGHT} rx={SLAT_RADIUS} ry={SLAT_RADIUS}/>
		)))}
	</g>;
};

export const mokVentsSide = {
	item: ventSlats,
	cutout: ventSlats
};
